__turbopack_context__.v({
  "cellWithTooltipLabel": "styles-module-scss-module__JjvTkG__cellWithTooltipLabel",
  "column": "styles-module-scss-module__JjvTkG__column",
  "label": "styles-module-scss-module__JjvTkG__label",
  "link": "styles-module-scss-module__JjvTkG__link",
  "nameCell": "styles-module-scss-module__JjvTkG__nameCell",
  "sectorLabel": "styles-module-scss-module__JjvTkG__sectorLabel",
  "statusIndicator": "styles-module-scss-module__JjvTkG__statusIndicator",
  "tagsCellItem": "styles-module-scss-module__JjvTkG__tagsCellItem",
  "tagsCellTooltipContent": "styles-module-scss-module__JjvTkG__tagsCellTooltipContent",
  "tagsCellTooltipItem": "styles-module-scss-module__JjvTkG__tagsCellTooltipItem",
  "tooltip": "styles-module-scss-module__JjvTkG__tooltip",
});
